module.exports = __webpack_public_path__ + "static/img/EcoAIBigData-banner.b3ec0ce3.jpg";